import React, { useCallback } from 'react';
import { RouteComponentProps } from 'react-router';

import useProduct from 'core/hooks/useProduct';
import { ProductFormSchema } from 'core/schemas/productForm';
import { FormSubmitHandler } from 'Elements/Form';

import ProductForm from './ProductPage/ProductForm';
import ProductPage from './ProductPage/ProductPage';

type Props = RouteComponentProps<{ id: string }>;

export default function ProductDetail({ match }: Props) {
  const { product, update } = useProduct(match.params.id);

  const onSubmit: FormSubmitHandler<ProductFormSchema> = useCallback(
    (values, form) => {
      return update(values.product).catch(errors =>
        form.setErrors({ product: errors })
      );
    },
    [update]
  );

  return (
    <ProductForm id={+match.params.id} onSubmit={onSubmit} product={product}>
      <ProductPage title={product ? product.name : '–'} />
    </ProductForm>
  );
}
